import { trpc } from '@/shared/api';

/** HOME 히어로 배너(landing.listHeroImages) — 사진과 연결 상품(공개 상품만, 없으면 null). 배열 순서가 노출 순서다. */
export const useLandingHeroImagesQuery = () => trpc.landing.listHeroImages.useQuery();
